{
  "seo": {
    "title": "Модуль расширенной аналитики для CRM — AI-отчёты и дашборды",
    "description": "Подключите расширенную аналитику к AmoCRM и другим CRM за 15 минут. AI-аналитик, сквозная аналитика, дашборды в Telegram. Демо-период 7 дней бесплатно.",
    "keywords": "аналитика CRM, amoCRM аналитика, сквозная аналитика, AI аналитика, дашборды CRM, отчёты Telegram, модуль аналитики CRM",
    "canonicalPath": "/analytics"
  },
  "nav": {
    "links": [
      {
        "label": "Как это работает",
        "href": "#how-it-works"
      },
      {
        "label": "Демо-отчёты",
        "href": "#demo-reports"
      },
      {
        "label": "Преимущества",
        "href": "#advantages"
      },
      {
        "label": "Калькулятор",
        "href": "#calculator"
      },
      {
        "label": "Интеграции",
        "href": "/integrations"
      }
    ],
    "cta": {
      "label": "Демо-период",
      "href": "#contact-form"
    }
  },
  "hero": {
    "badge": "Модуль расширенной аналитики для CRM",
    "title": "Превратите данные **вашей CRM** в **чистую прибыль**",
    "lead": "Ваша CRM уже собирает золото. Мы поможем его добыть.",
    "text": "Модуль расширенной аналитики подключается к AmoCRM и другим CRM за 15 минут без кодинга. AI-аналитик обрабатывает данные и присылает готовые отчёты в Telegram. Вы видите узкие места воронки, считаете LTV и знаете, на чём теряете деньги.",
    "primaryCta": {
      "label": "Бесплатная консультация",
      "href": "#contact-form"
    },
    "secondaryCta": {
      "label": "Попробовать демо-период",
      "href": "#demo-reports"
    },
    "stats": [
      {
        "value": "15 мин",
        "label": "Подключение к CRM"
      },
      {
        "value": "3×",
        "label": "Рост скорости отчётов"
      },
      {
        "value": "30%",
        "label": "Снижение потерь в воронке"
      },
      {
        "value": "24/7",
        "label": "AI-аналитик в Telegram"
      }
    ],
    "dashboard": {
      "caption": "Дашборд аналитики — Live",
      "metrics": [
        {
          "label": "Выручка, мес",
          "value": "₽4.2M",
          "change": "+12%",
          "positive": true
        },
        {
          "label": "Конверсия",
          "value": "23%",
          "change": "+5%",
          "positive": true
        },
        {
          "label": "Ср. чек",
          "value": "₽112к",
          "change": "+8%",
          "positive": true
        }
      ],
      "funnelTitle": "Воронка продаж — Конверсия по этапам",
      "funnel": [
        {
          "stage": "Заявки",
          "count": 340,
          "percent": 100,
          "tone": "blue-600"
        },
        {
          "stage": "Квалификация",
          "count": 245,
          "percent": 72,
          "tone": "blue-500"
        },
        {
          "stage": "КП",
          "count": 156,
          "percent": 46,
          "tone": "blue-400"
        },
        {
          "stage": "Переговоры",
          "count": 98,
          "percent": 29,
          "tone": "slate-400"
        },
        {
          "stage": "Сделка",
          "count": 78,
          "percent": 23,
          "tone": "emerald-500"
        }
      ],
      "insight": {
        "label": "AI-инсайт",
        "text": "Падение конверсии на этапе «КП → Переговоры». Рекомендую: A/B-тест шаблонов КП."
      }
    }
  },
  "howItWorks": {
    "badge": "Как это работает",
    "title": "От сырых данных — к **прибыльным решениям**",
    "subtitle": "Три простых шага, которые превращают хаос CRM в прозрачную картину бизнеса",
    "steps": [
      {
        "num": "01",
        "icon": "ri-database-2-line",
        "title": "Сбор данных",
        "text": "Модуль подключается к AmoCRM, телефонии, чатам и мессенджерам за 15 минут. Автоматически собирает все данные о сделках, звонках, переписке и задачах менеджеров.",
        "tags": [
          "AmoCRM",
          "Телефония",
          "Чаты",
          "Мессенджеры"
        ]
      },
      {
        "num": "02",
        "icon": "ri-brain-line",
        "title": "AI-обработка",
        "text": "Встроенный AI-аналитик обрабатывает сырые данные в реальном времени: выявляет паттерны, аномалии, прогнозирует выручку и находит узкие места воронки.",
        "tags": [
          "ML-модели",
          "Предиктивная аналитика",
          "Выявление аномалий"
        ]
      },
      {
        "num": "03",
        "icon": "ri-bar-chart-box-line",
        "title": "Готовые дашборды",
        "text": "Интерактивные отчёты в веб-интерфейсе и Telegram. Сквозная аналитика, здоровье воронки, LTV клиентов, прогноз продаж — всё в реальном времени.",
        "tags": [
          "Веб-дашборды",
          "Telegram-бот",
          "PDF-отчёты",
          "Умные уведомления"
        ]
      }
    ]
  },
  "demoReports": {
    "badge": "Демо-период",
    "title": "Попробуйте 3 готовых отчёта **бесплатно**",
    "subtitle": "Подключим демо-доступ за 15 минут. Вы получите реальные данные вашей CRM в красивых интерактивных дашбордах — без обязательств и предоплаты.",
    "cards": [
      {
        "icon": "ri-line-chart-line",
        "title": "Сквозная аналитика: от клика до прибыли",
        "text": "Отслеживайте путь клиента от первого касания до закрытой сделки. Видите, какие каналы маркетинга приносят реальную прибыль, а какие — просто тратят бюджет. ROI каждого рекламного канала в реальном времени.",
        "tags": [
          "ROI по каналам",
          "Цена лида → прибыль",
          "Атрибуция сделок"
        ],
        "demo": {
          "enabled": false,
          "kind": "iframe",
          "url": "",
          "title": "Сквозная аналитика: от клика до прибыли",
          "aspect": "16/9",
          "note": "Живое демо дашборда — вставьте ссылку на интерактивный отчёт"
        }
      },
      {
        "icon": "ri-funnel-line",
        "title": "Здоровье воронки и узкие места",
        "text": "В реальном времени видите, на каких этапах воронки теряются клиенты. AI-аналитик подсвечивает аномалии: резкое падение конверсии, затянутые сделки, перегрузку менеджеров. Вы получаете не просто цифры, а готовые рекомендации.",
        "tags": [
          "Конверсия этапов",
          "Скорость сделок",
          "AI-рекомендации"
        ],
        "demo": {
          "enabled": false,
          "kind": "iframe",
          "url": "",
          "title": "Здоровье воронки и узкие места",
          "aspect": "16/9",
          "note": "Живое демо дашборда — вставьте ссылку на интерактивный отчёт"
        }
      },
      {
        "icon": "ri-user-heart-line",
        "title": "LTV и повторные продажи",
        "text": "Считаем пожизненную ценность клиента (LTV), прогнозируем повторные продажи и отток. Сегментируем базу: кто готов к допродаже, кого пора возвращать, а кто — ваши адвокаты бренда. Работа с лояльностью становится системной.",
        "tags": [
          "LTV по сегментам",
          "Прогноз оттока",
          "Допродажи"
        ],
        "demo": {
          "enabled": false,
          "kind": "iframe",
          "url": "",
          "title": "LTV и повторные продажи",
          "aspect": "16/9",
          "note": "Живое демо дашборда — вставьте ссылку на интерактивный отчёт"
        }
      }
    ],
    "cta": {
      "label": "Активировать демо-период",
      "href": "#contact-form"
    },
    "note": "Без обязательств • 15 минут на подключение • 7 дней полного доступа"
  },
  "advantages": {
    "badge": "Преимущества",
    "title": "Почему компании выбирают **наш модуль**",
    "subtitle": "Сочетание AI, безопасности и простоты, которое меняет подход к аналитике в CRM",
    "keyLabel": "Ключевое",
    "cards": [
      {
        "icon": "ri-robot-line",
        "title": "Встроенный AI-аналитик с отчётами в Telegram",
        "text": "AI обрабатывает данные 24/7 и присылает персонализированные отчёты прямо в Telegram. Утренняя сводка по выручке, вечерний разбор узких мест воронки, мгновенные алерты при аномалиях. Вы всегда в курсе, даже без открытия CRM.",
        "key": true
      },
      {
        "icon": "ri-plug-line",
        "title": "Подключение за 15 минут без кодинга",
        "text": "Интеграция с AmoCRM через готовый API-коннектор. Не нужны разработчики, технические задания или долгие согласования. Вводите API-ключ — и данные начинают поступать. Поддержка Webhook и OAuth 2.0 для максимальной безопасности.",
        "key": true
      },
      {
        "icon": "ri-shield-check-line",
        "title": "Безопасность данных корпоративного уровня",
        "text": "Все данные хранятся в зашифрованном виде на серверах в РФ (152-ФЗ). Ролевая модель доступа, аудит действий, двухфакторная аутентификация. Ваши данные не покидают защищённый контур и недоступны третьим лицам.",
        "key": true
      },
      {
        "icon": "ri-crm-line",
        "title": "Универсальное подключение к любой CRM",
        "text": "Фокус на AmoCRM, но модуль работает и с другими CRM: Bitrix24, Salesforce, HubSpot, Zoho. Универсальный ETL-слой автоматически нормализует данные из любого источника. Одна аналитика — для любой экосистемы.",
        "key": false
      },
      {
        "icon": "ri-speed-mini-line",
        "title": "Real-time аналитика без задержек",
        "text": "Данные обновляются в реальном времени, а не раз в сутки. Видите, что происходит прямо сейчас: какие сделки подвисли, кто из менеджеров перегружен, где провал конверсии. Реагируйте мгновенно, а не постфактум.",
        "key": false
      },
      {
        "icon": "ri-slideshow-line",
        "title": "White-label и кастомизация дашбордов",
        "text": "Брендирование под ваш стиль, кастомные метрики и KPI, экспорт в PDF и Excel. Делитесь дашбордами с командой и руководством. Каждый сотрудник видит только свои показатели — настраиваемая ролевая модель.",
        "key": false
      }
    ]
  },
  "calculator": {
    "badge": "Калькулятор",
    "title": "Сколько вы теряете **без аналитики**?",
    "subtitle": "Передвиньте ползунок — и узнайте примерную сумму упущенной выгоды вашей компании",
    "sliderLabel": "Месячный оборот компании",
    "min": 100000,
    "max": 100000000,
    "step": 100000,
    "defaultValue": 5000000,
    "minLabel": "100 тыс ₽",
    "maxLabel": "100 млн ₽",
    "lossLabel": "Потери без аналитики",
    "lossNote": "~{{percent}}% от оборота",
    "recoveredLabel": "Можно вернуть",
    "recoveredNote": "с нашим модулем аналитики",
    "annualText": "За год это **{{annual}}**, которые вы оставляете на столе прямо сейчас",
    "cta": {
      "label": "Вернуть эти деньги",
      "href": "#contact-form"
    },
    "lossPercentBase": 10,
    "lossPercentRange": 12,
    "recoveryRate": 0.7
  },
  "form": {
    "title": "Запись на демо-период",
    "subtitle": "Заполните форму — и мы всё настроим",
    "submitLabel": "Активировать демо-период",
    "submittingLabel": "Отправляем...",
    "successTitle": "Спасибо!",
    "successText": "Мы свяжемся с вами в течение 15 минут. Проверьте Telegram или телефон — наш аналитик уже готовит для вас демо-доступ.",
    "successAgain": "Отправить ещё одну заявку",
    "consentLabel": "Я согласен с **политикой обработки персональных данных** и даю согласие на обработку моих персональных данных",
    "fields": {
      "name": "Имя",
      "namePlaceholder": "Иван Иванов",
      "phone": "Телефон / Telegram",
      "phonePlaceholder": "+7 (___) ___-__-__",
      "email": "Email",
      "emailPlaceholder": "your@company.ru",
      "crm": "Какая у вас CRM?",
      "managers": "Количество менеджеров в CRM",
      "message": "Задача или вопрос",
      "messagePlaceholder": "Расскажите о вашей задаче..."
    },
    "crmOptions": [
      {
        "value": "",
        "label": "Выберите CRM"
      },
      {
        "value": "amocrm",
        "label": "AmoCRM"
      },
      {
        "value": "bitrix24",
        "label": "Битрикс24"
      },
      {
        "value": "other",
        "label": "Другая"
      },
      {
        "value": "none",
        "label": "Пока нет CRM"
      }
    ],
    "managerOptions": [
      {
        "value": "1-3",
        "label": "1–3"
      },
      {
        "value": "4-10",
        "label": "4–10"
      },
      {
        "value": "11-30",
        "label": "11–30"
      },
      {
        "value": "31+",
        "label": "31+"
      }
    ],
    "bullets": [
      {
        "icon": "ri-time-line",
        "text": "Подключение демо за 15 минут"
      },
      {
        "icon": "ri-shield-check-line",
        "text": "Безопасность корпоративного уровня"
      },
      {
        "icon": "ri-gift-line",
        "text": "7 дней полного доступа бесплатно"
      }
    ],
    "errors": {
      "consent": "Необходимо согласие с политикой обработки персональных данных",
      "tooLong": "Сообщение не должно превышать 500 символов",
      "generic": "Не удалось отправить заявку. Попробуйте ещё раз.",
      "successToast": "Спасибо! Мы свяжемся с вами в течение 15 минут."
    }
  },
  "footer": {
    "description": "Модуль расширенной аналитики для CRM. AI-отчёты, дашборды и сквозная аналитика, которые помогают зарабатывать больше.",
    "columns": [
      {
        "title": "Возможности",
        "links": [
          {
            "text": "Сквозная аналитика",
            "href": "#demo-reports"
          },
          {
            "text": "AI-отчёты",
            "href": "#advantages"
          },
          {
            "text": "Дашборды",
            "href": "#how-it-works"
          },
          {
            "text": "Калькулятор",
            "href": "#calculator"
          },
          {
            "text": "Демо-период",
            "href": "#contact-form"
          }
        ]
      },
      {
        "title": "Компания",
        "links": [
          {
            "text": "О нас",
            "href": "/"
          },
          {
            "text": "Решения",
            "href": "/solutions"
          },
          {
            "text": "Интеграции",
            "href": "/integrations"
          },
          {
            "text": "Кейсы",
            "href": "/#cases"
          },
          {
            "text": "Тарифы",
            "href": "/#pricing"
          },
          {
            "text": "FAQ",
            "href": "/#faq"
          }
        ]
      },
      {
        "title": "Контакты",
        "links": [
          {
            "text": "amo@vnedrim-crm.ru",
            "href": "mailto:amo@vnedrim-crm.ru"
          },
          {
            "text": "+7 (977) 421-79-97",
            "href": "tel:+79774217997"
          },
          {
            "text": "Telegram",
            "href": "https://t.me/zapusti_amocrm"
          },
          {
            "text": "RuTube",
            "href": "https://rutube.ru/channel/26534827/videos/"
          }
        ]
      }
    ],
    "copyright": "© 2026 Быстренко.ру. Все права защищены. Сертифицированный партнёр amoCRM.",
    "legalLinks": [
      {
        "text": "Политика обработки персональных данных",
        "href": "/policy_pd.docx"
      },
      {
        "text": "Условия использования",
        "href": "#"
      }
    ]
  },
  "contactForm": {
    "badge": "Бесплатная консультация",
    "title": "Начните видеть **полную картину** вашего бизнеса",
    "text": "Оставьте заявку — подключим демо-доступ за 15 минут и покажем, как выглядит настоящая аналитика. Без обязательств и предоплаты."
  }
}
